// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"e68c3e44","879":"19d0a3ef"}[chunkId] + ".chunk.js";
};